import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GlobalConfigService } from "./global-config.service";
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { IModule } from "../models/module.model";
import { AuthService } from "./auth.service";

@Injectable({
    providedIn: 'root'
})

export class ModulesService {
    private get baseUrl(): string {
        return this.globalConfig.getApiUrl() + '/modules';
    }

    // Propriedades reativas (Observables)
    public readonly moduleName$: Observable<string>;
    public readonly moduleNameInSingular$: Observable<string>;
    public readonly moduleNamePascalCase$: Observable<string>;
    public readonly moduleId$: Observable<string>;

    constructor(
        private http: HttpClient,
        private globalConfig: GlobalConfigService,
        private authService: AuthService
    ) {
        // Criamos os observables derivados aqui no construtor.
        // Eles vão reagir automaticamente a mudanças no authService.selectedModule$

        this.moduleId$ = this.authService.selectedModule$.pipe(
            map(module => module.id)
        );

        this.moduleName$ = this.authService.selectedModule$.pipe(
            filter(module => !!module && !!module.description && module.description !== ''),
            map(module => {
                return module.description || ''
            })
        );

        this.moduleNamePascalCase$ = this.moduleName$.pipe(
            map(moduleName => {
                return moduleName.charAt(0).toUpperCase() + moduleName.slice(1).toLowerCase();
            })
        );

        this.moduleNameInSingular$ = this.moduleNamePascalCase$.pipe(
            map(moduleName => {
                if (moduleName.endsWith('res')) {
                    return moduleName.slice(0, -2);
                } else {
                    return moduleName.slice(0, -1);
                }
            })
        );
    }

    listModules(): Observable<IModule[]> {
        return this.http.get<IModule[]>(`${this.baseUrl}`);
    }

    // Getters síncronos para compatibilidade (se necessário)
    public get moduleName() {
        const module = this.authService.getSelectedModuleSync();
        return module.description || '';
    }

    public get moduleNamePascalCase() {
        const module = this.authService.getSelectedModuleSync();
        const description = module.description || '';
        return description.charAt(0).toUpperCase() + description.slice(1).toLowerCase();
    }

    public get moduleNameInSingular() {
        if (this.moduleNamePascalCase.endsWith('res')) {
            return this.moduleNamePascalCase.slice(0, -2);
        } else {
            return this.moduleNamePascalCase.slice(0, -1);
        }
    }

    public get moduleId() {
        const module = this.authService.getSelectedModuleSync();
        return module?.id || '';
    }
    
}